import React, { useCallback } from "react";
import { PageProps } from "gatsby";
import { RequestAQuotePageQuery } from "types/graphql-types";
import {
  SectionContainer,
  InlineFormContainer,
  SectionTitle,
  SectionTitleHeading,
  SectionTitleBody
} from "@silversea-ssc/ui-components-react";

const DefaultSubscribeForm = React.lazy(
  () => import("components/DefaultSubscribeForm/DefaultSubscribeForm")
);

import { isSSR } from "src/utils/ssr";
import { CruiseSuiteFormProps } from "components/DefaultSubscribeForm/useLeadForm";

const RequestAQuoteTemplate: React.FC<
  React.PropsWithChildren<
    PageProps<RequestAQuotePageQuery> & {
      card?: JSX.Element;
      cruiseSuiteForm?: CruiseSuiteFormProps;
    }
  >
> = (props) => {
  const { data } = props;
  const { thankYouPageURL } = data;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const page = data.page!;

  const onSubmitSuccess = useCallback(() => {
    if (!isSSR() && thankYouPageURL?.path) {
      window.location.href = thankYouPageURL?.path;
    }
  }, [thankYouPageURL?.path]);

  return (
    <React.Fragment>
      <SectionContainer
        spacingTop="regular"
        spacingBottom="condensed"
        backgroundColor="white"
      >
        <SectionTitle variant="wide">
          <SectionTitleHeading priority={1}>
            {page.heading?.title?.localized}
          </SectionTitleHeading>
          <SectionTitleBody>
            {page.heading?.subtitle?.localized}
          </SectionTitleBody>
        </SectionTitle>
      </SectionContainer>
      <SectionContainer spacingBottom="regular" backgroundColor="white">
        <InlineFormContainer>
          {props.card}
          <DefaultSubscribeForm
            formName="RequestAQuoteForm"
            onSubmitSuccess={onSubmitSuccess}
            requestSource="BKG"
            requestType="RAQ"
            askImNotTraveAgent={false}
            askWorkWithAgent={false}
            askPhone={true}
            phoneIsRequired
            askDescription={true}
            askAddress={false}
            dataContentName="raq_form"
            cruiseSuiteInfo={props.cruiseSuiteForm}
            formDisclaimerContent={data.formDisclaimerContent}
          />
        </InlineFormContainer>
      </SectionContainer>
    </React.Fragment>
  );
};

export default RequestAQuoteTemplate;
